import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Button, message } from "antd";
import { Outlet, useNavigate } from "react-router-dom";

const BrandsForm = ({ open, setOpen, data, isEdit, onSubmit }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      if (isEdit && data) {
        form.setFieldsValue(data);
      } else {
        form.resetFields();
      }
    }
  }, [open, isEdit, data, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      if (isEdit) {
        await onSubmit({ ...data, ...values });
      } else {
        await onSubmit(values);
      }
      form.resetFields();
      setOpen(false);
    } catch (err) {
      console.error(err);
      message.error(err.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button type="primary" style={{margin:10}} onClick={()=> navigate("/products/brands")}>
            Show Brands
        </Button>
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="Brand Name"
          name="name"
          rules={[{ required: true, message: "Please enter the brand name." }]}
        >
          <Input />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            block
            htmlType="submit"
            loading={isLoading}
          >
            {isEdit ? "Update Brand" : "Add Brand"}
          </Button>
        </Form.Item>
      </Form>
      </div>  );
};

export default BrandsForm;
